import Vue from 'vue';
import { mapGetters } from 'vuex';
import { modals } from '@/mixins/modal';
import dropsLoader from '@/mixins/components/drops-loader';
import tooltip from '@/mixins/components/tooltip';
import _ from 'lodash';
import InviteUser from './invite';
import EditUserModal from './edit-user-modal';

export default Vue.component('admin-sub-users', {
  template: require('./template.html'),
  name: 'admin-sub-users',
  mixins: [modals],
  components: {
    InviteUser,
    EditUserModal,
    dropsLoader,
    tooltip,
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'subUsers',
      'subUsersFetched',
    ]),
    subUserList() {
      const sortOn = this.sortKey || this.cols[0];
      return _.chain(this.subUsers)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                // only gather the cols the table needs from data
                const e = [];
                _.forEach(this.cols, (c) => {
                  // clean up the values so that the
                  // searchable items are like how
                  // the template is written
                  const col = this.cleanItem(row[c], c, row);
                  e.push(col);
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          const ascDesc = this.sortMap[sortOn];
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line
          return (a === b ? 0 : a < b ? 1 : -1) * ascDesc; // eslint-disable-line
        })
        .value();
    },
  },
  data() {
    const cols = ['email', 'fullname', 'status'];
    const sortMap = _.zipObject(cols, _.fill(Array(cols.length), -1));
    return {
      cols,
      sortMap,
      sortKey: '',
      filterKey: '',
      paginate: ['userlist'],
      loading: false,
      currentSubUser: {},
      modals: {
        inviteUser: false,
        editUser: false,
      },
    };
  },
  mounted() {
    // used for the modal mixin
    this.cls = '.adminUi-modalOverlay';
  },
  created() {
    if (!this.subUsersFetched) {
      this.getSubUsers();
    }
  },
  methods: {
    async getSubUsers() {
      try {
        this.loading = true;
        const { subUsers } = await this.$lightning([{
          name: 'getInvitedUsers',
        }]);
        this.$store.dispatch('setSubUsers', subUsers);
        this.$store.dispatch('setSubUsersFetched', true);
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
      } finally {
        this.loading = false;
      }
    },
    setSortKey(k) {
      this.sortKey = k;
      // Invert the value for ascDesc
      this.sortMap[k] = this.sortMap[k] * -1;
    },
    cleanItem(item) {
      return item || '--';
    },
    highlight(ctx, query, col) {
      const c = this.cleanItem(ctx, col);
      return c.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    setString(type) {
      let t = type;
      if (t.match(/sectionBlock/gi)) {
        t = 'section';
      } else if (t.match(/droplet/gi)) {
        t = 'droplet';
      }
      return t;
    },
    seperateCamalCase(str) {
      return str.replace(/([A-Z])/g, g => ` ${g[0].toLowerCase()}`);
    },
    setActiveSubUser(user) {
      this.currentSubUser = user;
      this.toggleModal('editUser', 'child');
    },
    toggleModal(type, c) {
      this.modals[type] = !this.modals[type];
      const content = !c ? this.$refs[type] : this.$refs[type].$el;
      if (this.modals[type]) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/sub-users/index.js